import { createRouter, createWebHistory } from 'vue-router';
import routes from '@/routes/website';
import { loadBranding } from '@/services/branding.service';

// Path-based tenants are served under `bioterapias.cl/<slug>`; a subdomain (or
// the apex) has no prefix. The base is read from the server-rendered branding
// bootstrap, which the middleware fills only for path-based requests.
const prefix = loadBranding().pathPrefix;
const base = prefix ? `${prefix}/` : '/';

const router = createRouter({
  history: createWebHistory(base),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Restore browser back/forward position; otherwise always start at the top
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

export default router;
